<template>
  <div class="c-panel c-panel--full">
    <div class="c-panel__item">
      <div class="u-txt--fair u-mrgn-bottom--3">{{ title }}</div>
      <div class="u-txt--base u-mrgn-bottom--3">
        <EllipsisText :lineNum=3 :message="desc" :expandLink="false" />
      </div>
      <div class="o-layout u-mrgn-bottom--3">
        <div v-for="(index,i) in infoTitle.length" :key="index" class="u-txt--base">
          <div class="o-layout__item u-2of4 u-mrgn-bottom--1 u-fg--ash-dark">{{ infoTitle[i] }}</div>
          <div class="o-layout__item u-2of4 u-mrgn-bottom--1">{{ infoData[i] }}</div>
        </div>
      </div>
      <div>
        <a :href="link">Selengkapnya</a>
      </div>
    </div>
  </div>
</template>

<script>
import EllipsisText from 'shared/components/Ellipsis/EllipsisText';

export default {
  name: 'GeneralItem',
  components: {
    EllipsisText
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    desc: {
      type: String,
      default: ""
    },
    link: {
      type: String,
      default: ""
    },
    infoTitle: {
      type: Array,
      default: () => []
    },
    infoData: {
      type: Array,
      default: () => []
    }
  }
};
</script>
